import {  LogLevel } from "@azure/msal-browser";
import { Config } from "./services/config";
export const msalConfig = {
    auth: {
        clientId: "81327740-9af5-4271-8c12-451734220f85",
        authority: "https://login.microsoftonline.com/a3e95c2e-9a60-4671-be2f-94f90325f7b9",
        redirectUri: Config.redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    system: {
    loggerOptions: {
        loggerCallback: (level, message) => {
            //console.log(`MSAL [${level}]: ${message}`);
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false,
    },
    },

};




export const loginRequest = {
    scopes: [
      "openid",
      "email",
      "profile",
      "User.Read",
      "User.ReadBasic.All"
    ],
    prompt: "select_account",
    account: null
  };